import {auth} from '@eitje/bridge'
import {Dropdown, DropdownItem, Icon, Layout} from '@eitje/web_components'
import {i18n, changeLanguage} from '~/initializers/i18n'
import {useDispatch} from 'react-redux'

export const Settings = () => {
	const dispatch = useDispatch()

	const switchLanguage = () => {
		const newLanguage = i18n.language === 'nl' ? 'en' : 'nl'
		dispatch({type: 'UPDATE_USER_SETTING', settings: {language: newLanguage}})
		changeLanguage(newLanguage)
	}

	return (
		<Layout className="navigation-dropdown">
			<Dropdown
				trigger={
					<Layout padding={16}>
						<Icon name="three-lines" />
					</Layout>
				}
			>
				<DropdownItem enableRole="admin" t="navigation_header.manage_admins" modalLink="/settings/admins" />
				<DropdownItem t="navigation_header.switch_language" onClick={switchLanguage} />
				<DropdownItem t="logout" onClick={() => auth.logout()} />
			</Dropdown>
		</Layout>
	)
}
